// localstorage var
export const WIZARD_PAGE_VIEWED = 'wizard_page_viewed';

export const EXTENDED_WARRANTY_2YEAR_ID = 476020;
export const EXTENDED_WARRANTY_3YEAR_ID = 476021;

export const MEMBERSHIP_1MONTH_SKU = 'JZ98-0040';
export const MEMBERSHIP_1YEAR_SKU = 'JZSE-0193';

export const MEMBERSHIP_SKUS = [MEMBERSHIP_1MONTH_SKU, MEMBERSHIP_1YEAR_SKU];

export const EXTENDED_WARRANTY_2YEAR_SKU = 'JZ98-0050';
export const EXTENDED_WARRANTY_3YEAR_SKU = 'JZ98-0051';
export const EXTENDED_WARRANTY_SKUS = [
  EXTENDED_WARRANTY_2YEAR_SKU,
  EXTENDED_WARRANTY_3YEAR_SKU,
];

export const SELECT_SIZE = 'select-size';
export const SIZING_KIT = 'sizing-kit';

export const RING_SIZES = [
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
];

export const OUT_OF_STOCK = 'outOfStock';
export const LOW_STOCK = 'lowStock';
export const IN_STOCK = 'inStock';
